<template>
    <div class="home-view">

      <div class="banner-box">

        <!-- 轮播图区域 -->
             <div class="banner-box-content">
                <div class="container" :style="{'--g': - swiper_index * 100  + '%'}">
                    <div class="swiper-img" v-for="(j, index) in swiperList" :key="index" :style="{'background-image': 'url(' + j.image + ')'}">
                    </div>
                </div>
               <div class="btn-container">
                 <div @click="uploads" class="btn btn-free" style="border-left-width: 6px;width: 109px;position: absolute;bottom: 265px;left: calc(49% - 581px);perspective: 1000px;">下载免费使用></div>
                 <!-- <div  class="btn btn-purchase" style="border-left-width: 6px;width: 107px;position: absolute;bottom: 265px;left: calc(49% - 401px);perspective: 1000px;">购买服务></div> -->
               </div>

               <!-- 指示器 -->
                 <div class="indicator left" :class="{active: swiper_index && swiperList.length > 1}" @click="leftIndicatorClick">
                    <img :src="left_indicator_pic" alt="">
                 </div>
                 <div class="indicator right" :class="{active: swiper_index !== swiperList.length - 1}" @click="rightIndicatorClick">
                    <img :src="right_indicator_pic" alt="">
                 </div>
             </div>
            <div class="banner-box-contaner u-flex u-row-between">
                <img class="banner-icon cursor" v-for="(img, index) in bannerList" :key="index" :src="img" alt="">
            </div>
        </div>
        <div class="safe-area" :style="{marginTop: '32px'}">
            <div class="bold font-40 text-center">{{ '服务工程企业·满足多种应用场景' }}</div>
            <div class="server-view u-m-t-60">
                <div class="server-view-item u-flex u-row-between" v-for="(server, index) in serverProductList" :key="index">
                    <div>
                        <div class="bold font-24 line-1 u-m-b-14">{{ server.name }}</div>
                        <span class="font-14 line-1">{{ server.sub }}</span>
                    </div>
                    <img class="server-view-img" :src="server.img" alt="">
                </div>
            </div>
        </div>
        <div class="safe-area display-table">
            <div class="bold font-40 text-center u-m-b-75">{{ '企业&项目部功能·满足管控场景' }}</div>
            <HomeViewProduct />
        </div>
        <div class="safe-area u-flex u-row-center">
            <div class="btn-style" @click="uploads">{{ btn_text }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'HomeView',
    components: {
        HomeViewProduct: () => import('@/components/HomeViewProduct/home-view-product.vue'),
    },
    data() {
        return {
            swiperList: [
            ],
            bannerList: [
                require('@/assets/home/sskanb-img.png'),
                require('@/assets/home/gxbj-img.png'),
                require('@/assets/home/rwxt-img.png'),
            ],
            serverProductList: [
                {
                    name: '云存储',
                    sub: '项目资料实时上云，随时查看',
                    img: require('@/assets/home/yun-icon.png'),
                    path: '/',
                },
                {
                    name: '任务发布',
                    sub: '发布人和接收人良好互动',
                    img: require('@/assets/home/rwfb-icon.png'),
                    path: '/',
                },
                {
                    name: '聚合数据',
                    sub: '自动汇聚各项目数据，生成看板',
                    img: require('@/assets/home/jhsju-icon.png'),
                    path: '/',
                },
                {
                    name: '工程签证、索赔',
                    sub: '及时建立、归集，减少漏项',
                    img: require('@/assets/home/gcqianz-icon.png'),
                    path: '/',
                },
                {
                    name: '成本控制',
                    sub: '图纸抽量、询价比价、采购结算',
                    img: require('@/assets/home/cbguanl-icon.png'),
                    path: '/',
                },
                {
                    name: '提升管理',
                    sub: '信息共享、协作共管、资料保障',
                    img: require('@/assets/home/tsgli-icon.png'),
                    path: '/',
                },
            ],
            btn_text: '下载免费使用',
            left_indicator_pic: require('@/assets/home/jt-icon.png'),
            right_indicator_pic: require('@/assets/home/jjt-icon.png'),
            swiper_index: 0,
        }
    },
	mounted() {
		this.fetchWebsiteConfig();
	},
    methods: {
		async fetchWebsiteConfig() {
			const response = await fetch(this.$apiBaseUrl+"/api/website/banner",{method: 'POST',body: new URLSearchParams({type: 1}).toString()});
			const data = await response.json();
			console.log(data.data)
			this.swiperList=data.data
		},
        leftIndicatorClick() {
            if (!this.swiper_index) return;
            this.swiper_index--;
        },
        rightIndicatorClick() {
            if (this.swiper_index === this.swiperList.length - 1) return;
            this.swiper_index++;
        },
		uploads(){
			this.$router.push("/download");
			window.scrollTo({ top: 0, behavior: 'smooth' });
		}
		
    }
}
</script>

<style lang="scss" scoped>
.home-view {
    background: linear-gradient(to bottom right, #fff, #DDEDFC);
    .banner-box {
        height: 1000px;
        position: relative;
        top: -90px;
      /* 按钮容器样式 */
      .btn-container {
        display: flex;
        gap: 15px;
        padding: 20px;
      }

      /* 基础按钮样式 */
      .btn {
        padding: 12px 20px;
        font-size: 16px;
        font-weight: 800;
        text-align: center;
        cursor: pointer;
        // border-radius: 4px;
        transition: all 0.3s ease;
      }

      /* 免费使用按钮 */
      .btn-free {
		border-left-width: 6px;  /* 左边框更宽 */
		border: 2px solid #005EE5;
		background-color: #E2F1FA;
		color: #005EE5;
      }

      /* 购买服务按钮 */
      .btn-purchase {
        border: none;
		border: 2px solid #ff9800;
        background-color: #DBE9FB;
        color: #ff9800;
      }

      /* 按钮悬停效果 */
      .btn:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 8px rgba(0,0,0,0.1);
      }
        &-contaner {
            width: 1200px;
            height: 144px;
            position: absolute;
            bottom: -72px;
            left: calc(50% - 600px);
            
            /* 为容器添加透视效果 */
            perspective: 1000px;
            
            .banner-icon {
                height: 115px;
                box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
                border-radius: 8px;
                transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
                cursor: pointer;
                position: relative;
                z-index: 1;
                
                /* 添加3D变换和硬件加速 */
                transform: translateZ(0);
                
                /* 悬停效果 */
                &:hover {
                    transform: scale(1.15) translateY(-10px) translateZ(0);
                    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.25);
                    z-index: 10;
                    
                    /* 添加边框高亮效果 */
                    // border: 2px solid rgba(0, 94, 229, 0.8);
                    
                    /* 添加微妙的发光效果 */
                    &::after {
                        content: '';
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        border-radius: 8px;
                        box-shadow: 0 0 20px rgba(0, 94, 229, 0.4);
                        opacity: 1;
                        z-index: -1;
                    }
                }
            }
        }
        &-content {
            width: 100%;
            height: 100%;
            position: relative;
            overflow: hidden;
            .container {
                height: 100%;
                display: flex;
                transition: transform 0.5s;
                transform: translateX(var(--g));
                .swiper-img {
                    width: 100%;
                    height: 100%;
                    background-size: cover;
                    background-position: center;
                    background-repeat: no-repeat;
                    flex: none;
                }
            }
            .indicator {
                width: 60px;
                height: 38px;
                position: absolute;
                bottom: 98px;
                right: calc(15% - 30px);
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                & > img {
                    position: relative;
                    z-index: 3;
                    height: 26px;
                }
                &::before {
                    content: '';
                    width: 50px;
                    height: 38px;
                    position: absolute;
                    z-index: 2;
                    left: 6px;
                    background-color: rgba($color: #000000, $alpha: 0.2);
                    box-shadow: 2px 2px 8px 0px rgba(52, 92, 156, 0.27);
                    transform: skewX(-20deg);
                }
                &.left {
                    right: calc(18% -  15px);
                    bottom: 90px;
                }
                &.active {
                    &::before {
                        background: linear-gradient(20deg, #085AA9, #34BDEF);
                    }
                }
            }
        }
    }
    .server-view {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-gap: 30px;
        margin-bottom: 123px;
        
        /* 为网格容器添加透视 */
        perspective: 1000px;
        
        &-item {
            padding: 5px 24px;
            background: #fff;
            box-shadow: 0px 0px 18px 0px rgba(18,87,174,0.14);
            border-radius: 4px;
            transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
            cursor: pointer;
            position: relative;
            overflow: hidden;
            
            /* 添加3D变换和硬件加速 */
            transform: translateZ(0);
            
            /* 添加悬停前的微动画 */
            &:hover {
                transform: scale(1.08) translateY(-8px) translateZ(0);
                box-shadow: 0 15px 30px rgba(18, 87, 174, 0.25);
                z-index: 5;
                
                /* 添加边框高亮效果 */
                // border: 1px solid rgba(0, 94, 229, 0.5);
                
                /* 添加微妙的背景渐变变化 */
                background: linear-gradient(to bottom, #fff, #f0f7ff);
                
                /* 添加悬停时图标放大效果 */
                .server-view-img {
                    transform: scale(1.1);
                }
                
                /* 添加悬停时文字颜色变化 */
                .bold {
                    color: #005EE5;
                }
                
                /* 添加悬停时底部发光效果 */
                &::after {
                    content: '';
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    height: 3px;
                    // background: linear-gradient(to right, #085AA9, #34BDEF);
                    border-radius: 0 0 4px 4px;
                }
            }
            
            .server-view-img {
                width: 116px;
                transition: transform 0.3s ease;
            }
        }
    }
    .btn-style {
        border: 1px solid #005EE5;
        color: #005EE5;
        padding: 20px 80px;
        border-radius: 8px;
        cursor: pointer;
        margin: 65px 0 50px;
        transition: all 0.3s ease;
        position: relative;
        overflow: hidden;
        
        &:hover {
            color: #fff;
            background-color: #005EE5;
            transform: translateY(-3px);
            box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
        }
        
        &:active {
            transform: translateY(-1px);
        }
    }
}

/* 响应式设计 - 在较小屏幕上调整悬停效果 */
@media (max-width: 768px) {
    .home-view .banner-box-contaner .banner-icon:hover {
        transform: scale(1.08) translateY(-5px);
    }
    
    .home-view .server-view-item:hover {
        transform: scale(1.05) translateY(-5px);
    }
    
    .home-view .server-view {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 480px) {
    .home-view .server-view {
        grid-template-columns: 1fr;
    }
}
</style>